(() => {
  'use strict';
  const root = document.querySelector('[data-bb-product]');
  if (!root) return;
  const variants = JSON.parse(root.querySelector('[data-bb-variants]')?.textContent || '[]');
  const byId = id => variants.find(v => v.id === Number(id));
  let current = byId(root.querySelector('.bb-swatch[aria-checked="true"]')?.dataset.bbVariant) || variants.find(v => v.available) || variants[0];

  /* Galerie */
  const track = root.querySelector('[data-bb-track]');
  const slides = track ? [...track.children] : [];
  const thumbs = [...root.querySelectorAll('[data-bb-goto]')];
  const thumbsBox = root.querySelector('[data-bb-thumbs]');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Images différées (data-srcset) : posées après le chargement ou au premier geste. Sur téléphone, 800 px max. */
  const phone = matchMedia('(max-width: 749px)').matches;
  const hydrate = img => {
    if (!img || !img.dataset.srcset) return;
    const set = img.dataset.srcset.split(',').filter(p => !phone || !img.closest('.bb-gallery-slide') || parseInt(p.trim().split(' ')[1], 10) <= 800).join(',');
    img.dataset.full = img.dataset.srcset; img.srcset = set; img.src = img.dataset.src || ''; delete img.dataset.srcset;
    /* data-early retiré : sinon le petit script de la fiche (qui vise .bb-thumb img[data-early]) repassait derrière et
       écrivait srcset="undefined" → 4 premières vignettes vides + requête /products/undefined en 404 (audit du 19/10/2026). */
    delete img.dataset.early;
  };
  const slideImg = i => slides[i]?.querySelector('img');
  const near = i => {for (let k = i - 1; k <= i + 1; k++) hydrate(slideImg(k));};
  let thumbsDone = false;
  const allThumbs = () => {if (thumbsDone) return; thumbsDone = true; root.querySelectorAll('.bb-thumb img[data-srcset]').forEach(hydrate);};
  const mark = i => thumbs.forEach(b => b.setAttribute('aria-current', String(Number(b.dataset.bbGoto) === i)));
  /* Vignettes : on ne fait défiler QUE la rangée de vignettes (scrollIntoView faisait aussi remonter la page et
     coupait le défilement de la grande image en cours : choisir un design arrivait sur une autre image). Audit du 18/10/2026. */
  const showThumb = i => {
    const th = thumbs[i];
    if (!th || !thumbsBox) return;
    const delta = th.getBoundingClientRect().left - thumbsBox.getBoundingClientRect().left;
    thumbsBox.scrollTo({left: thumbsBox.scrollLeft + delta - (thumbsBox.clientWidth - th.offsetWidth) / 2, behavior: 'auto'});
  };
  let target = null, targetTimer;
  const goTo = (i, instant) => {
    if (!track || !slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    /* pendant le défilement animé, la rangée de vignettes ne bouge plus (sinon Chrome coupe l'animation à mi-chemin) */
    target = instant ? null : i; clearTimeout(targetTimer); targetTimer = setTimeout(() => {target = null;}, 1500);
    near(i); slideImg(i)?.setAttribute('loading', 'eager');
    track.scrollTo({left: track.clientWidth * i, behavior: reduce || instant ? 'auto' : 'smooth'});
    mark(i);
    showThumb(i);
  };
  thumbs.forEach(b => b.addEventListener('click', () => goTo(Number(b.dataset.bbGoto))));
  root.querySelector('[data-bb-thumbs-prev]')?.addEventListener('click', () => {allThumbs(); thumbsBox?.scrollBy({left: -thumbsBox.clientWidth, behavior: 'smooth'});});
  root.querySelector('[data-bb-thumbs-next]')?.addEventListener('click', () => {allThumbs(); thumbsBox?.scrollBy({left: thumbsBox.clientWidth, behavior: 'smooth'});});
  thumbsBox?.addEventListener('scroll', allThumbs, {passive: true, once: true});
  track?.addEventListener('touchstart', () => near(Math.round(track.scrollLeft / track.clientWidth)), {passive: true, once: true});
  /* Dès que la photo principale est arrivée (ou au bout de 2,5 s) : pastilles des designs, 4 premières vignettes, 1er mini-avis.
     Avant, tout partait en même temps et la photo principale arrivait en dernier sur une connexion lente. */
  let topDone = false;
  const top = () => {
    if (topDone) return; topDone = true;
    root.querySelectorAll('.bb-swatch img[data-srcset], .bb-thumb img[data-early]').forEach(hydrate);
    const mini = document.querySelector('[data-bb-mini] img[data-src]'); if (mini) {mini.src = mini.dataset.src; mini.removeAttribute('data-src');}
  };
  const mainImg = slideImg(0);
  if (!mainImg || mainImg.complete) top(); else {mainImg.addEventListener('load', top, {once: true}); mainImg.addEventListener('error', top, {once: true}); setTimeout(top, 2500);}
  /* Après le chargement complet : les 2 photos suivantes et les vignettes (le haut de page est déjà affiché). */
  const later = () => {top(); near(1); allThumbs();};
  if (document.readyState === 'complete') setTimeout(later, 800); else addEventListener('load', () => setTimeout(later, 800), {once: true});
  let raf, shown = 0;
  track?.addEventListener('scroll', () => {cancelAnimationFrame(raf); raf = requestAnimationFrame(() => {const i = Math.round(track.scrollLeft / track.clientWidth); near(i); if (target !== null) {if (i === target) target = null; return;} mark(i); if (i !== shown) {shown = i; showThumb(i);}});}, {passive: true});

  /* Photo en plein écran : toucher la photo (ou la loupe) l'ouvre ; balayer pour changer ; × , Échap ou « retour » du téléphone ferment.
     Le zoom à deux doigts du téléphone reste possible (pas de maximum-scale). TRIKOLUMO n'a pas de plein écran : ajout du 18/10/2026. */
  const zoom = root.querySelector('[data-bb-zoom]');
  if (zoom && zoom.showModal && track) {
    const ztrack = zoom.querySelector('[data-bb-zoom-track]');
    const count = zoom.querySelector('[data-bb-zoom-count]');
    let built = false;
    const build = () => {
      if (built) return; built = true;
      slides.forEach(s => {
        const src = s.querySelector('img'); const d = document.createElement('div'); d.className = 'bb-zoom-slide';
        const im = document.createElement('img'); im.alt = src?.alt || ''; im.loading = 'lazy'; im.decoding = 'async'; im.sizes = '100vw';
        im.srcset = src?.dataset.full || src?.dataset.srcset || src?.getAttribute('srcset') || ''; im.src = src?.dataset.src || src?.getAttribute('src') || '';
        d.appendChild(im); ztrack.appendChild(d);
      });
    };
    let zcur = 0; /* index retenu pendant l'ouverture : à la fermeture la piste est masquée et sa position remise à 0 */
    const zi = () => ztrack.clientWidth ? Math.round(ztrack.scrollLeft / ztrack.clientWidth) : zcur;
    const paint = () => {zcur = zi(); if (count) count.textContent = (zcur + 1) + ' / ' + slides.length;};
    const zgo = i => {i = Math.max(0, Math.min(slides.length - 1, i)); ztrack.children[i]?.querySelector('img')?.setAttribute('loading', 'eager'); ztrack.scrollTo({left: ztrack.clientWidth * i, behavior: 'auto'}); paint();};
    const open = i => {build(); zoom.showModal(); document.body.style.overflow = 'hidden'; requestAnimationFrame(() => zgo(i)); try {history.pushState({bbZoom: 1}, '');} catch (e) {}};
    zoom.addEventListener('close', () => {document.body.style.overflow = ''; goTo(zcur, true); if (history.state && history.state.bbZoom) history.back();});
    addEventListener('popstate', () => {if (zoom.open) zoom.close();});
    let zraf; ztrack.addEventListener('scroll', () => {cancelAnimationFrame(zraf); zraf = requestAnimationFrame(paint);}, {passive: true});
    zoom.querySelector('[data-bb-zoom-close]')?.addEventListener('click', () => zoom.close());
    zoom.querySelector('[data-bb-zoom-prev]')?.addEventListener('click', () => zgo(zi() - 1));
    zoom.querySelector('[data-bb-zoom-next]')?.addEventListener('click', () => zgo(zi() + 1));
    zoom.addEventListener('keydown', e => {if (e.key === 'ArrowRight') zgo(zi() + 1); if (e.key === 'ArrowLeft') zgo(zi() - 1);});
    track.addEventListener('click', e => {const s = e.target.closest('.bb-gallery-slide'); if (s) open(slides.indexOf(s));});
    root.querySelector('[data-bb-zoom-open]')?.addEventListener('click', () => open(Math.round(track.scrollLeft / track.clientWidth)));
  }

  /* Designs */
  const nameEl = root.querySelector('[data-bb-variant-name]');
  const setSlotImg = select => {
    const v = byId(select.value); const pick = select.closest('.bb-slot-pick');
    const img = pick?.querySelector('[data-bb-slot-img]'); if (v && img && v.image) img.src = v.image;
    const nm = pick?.querySelector('[data-bb-slot-name]'); if (v && nm) nm.textContent = v.title;
  };
  const chooseVariant = (v, fromUser) => {
    if (!v) return;
    current = v;
    root.querySelectorAll('.bb-swatch').forEach(s => s.setAttribute('aria-checked', String(Number(s.dataset.bbVariant) === v.id)));
    if (nameEl) nameEl.textContent = v.title;
    root.querySelectorAll('.bb-tier-designs').forEach(box => {const first = box.querySelector('[data-bb-slot]'); if (first) {first.value = String(v.id); setSlotImg(first);}});
    if (fromUser) {
      const idx = slides.findIndex(s => Number(s.dataset.mediaId) === v.media);
      if (idx >= 0) goTo(idx, true);
      const url = new URL(location.href); url.searchParams.set('variant', String(v.id)); history.replaceState({}, '', url);
    }
  };
  root.querySelectorAll('.bb-swatch').forEach(s => s.addEventListener('click', () => chooseVariant(byId(s.dataset.bbVariant), true)));
  /* « Alle 34 Designs anzeigen » / « Weniger » : en refermant, le bouton reste sous le doigt (pas de saut de page). */
  root.querySelector('[data-bb-more-designs]')?.addEventListener('click', e => {
    const btn = e.currentTarget; const box = root.querySelector('[data-bb-swatches]'); const open = !box.classList.contains('bb-open');
    const before = btn.getBoundingClientRect().top;
    box.classList.toggle('bb-open', open); btn.setAttribute('aria-expanded', String(open));
    btn.dataset.label = btn.dataset.label || btn.textContent; btn.textContent = open ? (btn.dataset.labelOpen || 'Weniger Designs anzeigen') : btn.dataset.label;
    if (!open) window.scrollBy({top: btn.getBoundingClientRect().top - before, behavior: 'instant'});
  });
  root.querySelectorAll('[data-bb-slot]').forEach(sel => sel.addEventListener('change', () => {setSlotImg(sel); const box = sel.closest('.bb-tier-designs'); if (box && box.querySelector('[data-bb-slot]') === sel) chooseVariant(byId(sel.value), true);}));
  root.querySelectorAll('[data-bb-slot]').forEach(setSlotImg);

  /* Menus « Design #1 #2 #3 » des lots : liste déroulante maison comme    (grande image + nom, une ligne par design)
     au lieu du menu natif iOS / Android. Le <select> reste dans la page, caché et synchronisé : un choix y écrit la valeur
     et déclenche « change » comme avant (image, nom, panier inchangés). Fermeture : choix, toucher à côté, Échap, retour
     du téléphone. Demande d'Adama du 19/10/2026. */
  const ddHeader = document.querySelector('.bb-header');
  const ddThumb = v => (v && v.image ? v.image.replace(/([?&]width=)\d+/, '$1120') : '');
  let ddCur = null, ddPushed = false, ddSkipPop = false, ddY = null;
  const ddClose = ({focus = false, fromPop = false, keepHistory = false} = {}) => {
    const dd = ddCur; if (!dd) return; ddCur = null;
    dd.list.hidden = true; dd.btn.setAttribute('aria-expanded', 'false'); dd.box.classList.remove('bb-dd-open', 'bb-dd-up');
    if (focus) dd.btn.focus({preventScroll: true});
    if (fromPop) ddPushed = false;
    else if (ddPushed && !keepHistory) {ddPushed = false; ddSkipPop = true; ddY = scrollY; history.back();}
  };
  const ddBuild = dd => {
    if (dd.built) return; dd.built = true;
    const frag = document.createDocumentFragment();
    [...dd.sel.options].forEach(opt => {
      const li = document.createElement('li');
      li.setAttribute('role', 'option'); li.id = dd.list.id + '-' + opt.value; li.dataset.value = opt.value; li.tabIndex = -1;
      if (opt.disabled) li.setAttribute('aria-disabled', 'true');
      const im = document.createElement('img'); im.alt = ''; im.width = 60; im.height = 60; im.loading = 'lazy'; im.decoding = 'async'; im.src = ddThumb(byId(opt.value));
      const nm = document.createElement('span'); nm.textContent = opt.text;
      li.append(im, nm); frag.appendChild(li);
    });
    dd.list.appendChild(frag);
  };
  /* Sous le bouton s'il y a la place, sinon au-dessus, sinon la page défile juste assez pour que la liste tienne en dessous. */
  const ddPlace = dd => {
    const list = dd.list; const vh = innerHeight;
    const top = ddHeader ? Math.max(0, ddHeader.getBoundingClientRect().bottom) : 0;
    list.style.maxHeight = ''; dd.box.classList.remove('bb-dd-up');
    const want = Math.min(list.scrollHeight + 2, Math.round(vh * 0.6));
    let r = dd.btn.getBoundingClientRect();
    const below = vh - r.bottom - 12, above = r.top - top - 12;
    if (below >= want) {list.style.maxHeight = want + 'px'; return;}
    if (above >= want) {dd.box.classList.add('bb-dd-up'); list.style.maxHeight = want + 'px'; return;}
    window.scrollBy({top: Math.max(0, Math.min(want - below, r.top - top - 8)), behavior: 'instant'});
    r = dd.btn.getBoundingClientRect();
    list.style.maxHeight = Math.max(160, Math.min(want, vh - r.bottom - 12)) + 'px';
  };
  const ddFocus = (dd, li) => {
    if (!li) return;
    li.focus({preventScroll: true});
    const lt = dd.list.scrollTop, lh = dd.list.clientHeight, ot = li.offsetTop, oh = li.offsetHeight;
    if (ot < lt) dd.list.scrollTop = ot; else if (ot + oh > lt + lh) dd.list.scrollTop = ot + oh - lh;
  };
  const ddOpen = (dd, viaKey) => {
    if (ddCur === dd) return;
    const had = !!ddCur; ddClose({keepHistory: true});
    ddBuild(dd);
    const val = dd.sel.value;
    dd.list.querySelectorAll('[role=option]').forEach(o => o.setAttribute('aria-selected', String(o.dataset.value === val)));
    dd.list.hidden = false; dd.btn.setAttribute('aria-expanded', 'true'); dd.box.classList.add('bb-dd-open');
    ddCur = dd; ddPlace(dd);
    const cur = dd.list.querySelector('[aria-selected=true]') || dd.list.querySelector('[role=option]');
    if (cur) dd.list.scrollTop = Math.max(0, cur.offsetTop - (dd.list.clientHeight - cur.offsetHeight) / 2);
    if (viaKey) ddFocus(dd, cur); else dd.list.focus({preventScroll: true});
    if (!had && !ddPushed) {try {history.pushState({bbDd: 1}, ''); ddPushed = true;} catch (e) {}}
  };
  const ddChoose = (dd, li) => {
    if (!li || li.getAttribute('aria-disabled') === 'true') return;
    if (dd.sel.value !== li.dataset.value) {dd.sel.value = li.dataset.value; dd.sel.dispatchEvent(new Event('change', {bubbles: true}));}
    ddClose({focus: true});
  };
  root.querySelectorAll('.bb-slot-pick').forEach((pick, k) => {
    const sel = pick.querySelector('[data-bb-slot]'); if (!sel) return;
    const label = sel.getAttribute('aria-label') || 'Design';
    const box = document.createElement('div'); box.className = 'bb-slot-pick bb-dd';
    const btn = document.createElement('button'); btn.type = 'button'; btn.className = 'bb-dd-btn';
    btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-controls', 'bb-dd-' + k);
    const hid = document.createElement('span'); hid.className = 'bb-vh'; hid.textContent = label + ': ';
    const nm = document.createElement('span'); nm.className = 'bb-dd-name'; nm.setAttribute('data-bb-slot-name', '');
    const chev = document.createElement('span'); chev.className = 'bb-dd-chev'; chev.setAttribute('aria-hidden', 'true');
    const img = pick.querySelector('[data-bb-slot-img]');
    btn.append(hid); if (img) {img.loading = 'eager'; btn.append(img);} btn.append(nm, chev);
    const list = document.createElement('ul'); list.className = 'bb-dd-list'; list.id = 'bb-dd-' + k; list.hidden = true; list.tabIndex = -1;
    list.setAttribute('role', 'listbox'); list.setAttribute('aria-label', label);
    sel.classList.add('bb-dd-native'); sel.tabIndex = -1; sel.setAttribute('aria-hidden', 'true');
    box.append(btn, list, sel); pick.replaceWith(box);
    const dd = {box, btn, list, sel};
    btn.addEventListener('click', e => (ddCur === dd ? ddClose({focus: true}) : ddOpen(dd, e.detail === 0)));
    btn.addEventListener('keydown', e => {if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {e.preventDefault(); ddOpen(dd, true);}});
    list.addEventListener('click', e => ddChoose(dd, e.target.closest('[role=option]')));
    list.addEventListener('keydown', e => {
      const opts = [...list.querySelectorAll('[role=option]:not([aria-disabled=true])')];
      let i = opts.indexOf(document.activeElement);
      if (i < 0) i = opts.findIndex(o => o.getAttribute('aria-selected') === 'true');
      const go = j => {e.preventDefault(); ddFocus(dd, opts[Math.max(0, Math.min(opts.length - 1, j))]);};
      if (e.key === 'ArrowDown') go(document.activeElement === list ? i : i + 1);
      else if (e.key === 'ArrowUp') go(document.activeElement === list ? i : i - 1);
      else if (e.key === 'Home') go(0);
      else if (e.key === 'End') go(opts.length - 1);
      else if (e.key === 'PageDown') go(i + 5);
      else if (e.key === 'PageUp') go(i - 5);
      else if (e.key === 'Enter' || e.key === ' ') {e.preventDefault(); ddChoose(dd, document.activeElement.closest?.('[role=option]') || opts[i]);}
      else if (e.key === 'Escape') {e.preventDefault(); e.stopPropagation(); ddClose({focus: true});}
      else if (e.key === 'Tab') ddClose();
      else if (e.key.length === 1 && /\S/.test(e.key)) {
        const c = e.key.toUpperCase(); const n = opts.length;
        for (let s = 1; s <= n; s++) {const o = opts[(i + s) % n]; if (o.textContent.trim().toUpperCase().startsWith(c)) {go((i + s) % n); break;}}
      }
    });
    setSlotImg(sel);
  });
  document.addEventListener('pointerdown', e => {if (ddCur && !ddCur.box.contains(e.target)) ddClose();}, true);
  document.addEventListener('keydown', e => {if (e.key === 'Escape' && ddCur) ddClose({focus: true});});
  addEventListener('popstate', () => {
    /* retour lancé par nous à la fermeture : le navigateur remet la page où elle était à l'ouverture, on la laisse où elle est */
    if (ddSkipPop) {ddSkipPop = false; if (ddY !== null && !ddCur) window.scrollTo({top: ddY, behavior: 'instant'}); ddY = null; return;}
    if (ddCur) ddClose({focus: true, fromPop: true}); else ddPushed = false;
  });

  /* Lots */
  const tiers = [...root.querySelectorAll('[data-bb-tier]')];
  const pickTier = tier => tiers.forEach(t => t.setAttribute('aria-checked', String(t === tier)));
  tiers.forEach(t => {
    t.addEventListener('click', e => {if (e.target.closest('select')) return; pickTier(t);});
    t.addEventListener('keydown', e => {if (e.target.closest('.bb-dd')) return; if (e.key === ' ' || e.key === 'Enter') {e.preventDefault(); pickTier(t);}});
  });

  /* Raccourcis vers l'offre des pubs (audit conversion du 19/10/2026) : la pastille « 2 gekauft + 1 gratis » sous le prix et le bandeau « Weihnachtsangebot » choisissent le lot indiqué et l'amènent à l'écran avec le bouton (lot à ~80 px du haut). Sans script, le lien #bb-offer descend aux offres. */
  document.querySelectorAll('[data-bb-goto-tier]').forEach(link => link.addEventListener('click', e => {
    const t = tiers.find(x => x.dataset.bbTier === link.dataset.bbGotoTier);
    if (!t) return;
    e.preventDefault();
    pickTier(t);
    const y = t.getBoundingClientRect().top + scrollY - 80;
    window.scrollTo({top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth'});
    t.focus({preventScroll: true});
  }));

  /* Ajout au panier */
  const button = root.querySelector('[data-bb-add]');
  const error = root.querySelector('[data-bb-error]');
  const label = button?.textContent;
  button?.addEventListener('click', async () => {
    const tier = tiers.find(t => t.getAttribute('aria-checked') === 'true') || tiers[0];
    const qty = Number(tier?.dataset.qty || 1);
    let ids = [...tier.querySelectorAll('[data-bb-slot]')].map(s => Number(s.value)).slice(0, qty);
    if (!ids.length) ids = Array(qty).fill(current.id);
    const counts = {};
    ids.forEach(id => {counts[id] = (counts[id] || 0) + 1;});
    const items = Object.entries(counts).map(([id, quantity]) => ({id: Number(id), quantity}));
    if (items.some(i => !byId(i.id)?.available)) {error.textContent = 'Dieses Design ist gerade nicht verfügbar. Bitte wähle ein anderes.'; error.hidden = false; return;}
    button.disabled = true; button.textContent = 'Wird hinzugefügt …'; error.hidden = true;
    try {
      const routes = (window.Brixbaer || {}).routes || {};
      const r = await fetch((routes.add || '/cart/add') + '.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items})});
      const data = await r.json();
      if (!r.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Der Artikel konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
      document.dispatchEvent(new CustomEvent('brixbaer:cart-added', {detail: data}));
      if (window.BrixbaerCart) await window.BrixbaerCart.open(button); else location.href = (routes.cart || '/cart');
    } catch (e) {error.textContent = e.message; error.hidden = false;}
    finally {button.disabled = false; button.textContent = label;}
  });

  /* Barre d'achat collante (téléphone) : visible une fois le bouton d'achat dépassé, ramène aux offres. */
  const sticky = document.querySelector('[data-bb-sticky]');
  if (sticky && button && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;}).observe(button);
    sticky.querySelector('a')?.addEventListener('click', e => {e.preventDefault(); root.querySelector('#bb-offer')?.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block: 'start'});});
  }

  /* Avis courts sous le bouton */
  document.querySelectorAll('[data-bb-mini]').forEach(box => {
    const tr = box.querySelector('.bb-mini-track');
    /* photos des avis suivants : posées au premier défilement ou après le chargement complet */
    const show = () => box.querySelectorAll('img[data-src]').forEach(im => {im.src = im.dataset.src; im.removeAttribute('data-src');});
    tr?.addEventListener('scroll', show, {passive: true, once: true});
    box.querySelector('.bb-mini-next')?.addEventListener('click', show, {once: true});
    if (document.readyState === 'complete') setTimeout(show, 1500); else addEventListener('load', () => setTimeout(show, 1500), {once: true});
    box.querySelector('.bb-mini-next')?.addEventListener('click', () => {
      const end = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4;
      tr.scrollTo({left: end ? 0 : tr.scrollLeft + tr.clientWidth, behavior: reduce ? 'auto' : 'smooth'});
    });
  });
})();

/* Vidéos des sections : rien n'est chargé à l'ouverture (preload none), chaque vidéo se charge et se lance quand
   elle arrive près de l'écran, et se met en pause quand elle en sort (correction du 18/10/2026). */
(() => {
  'use strict';
  const vids = document.querySelectorAll('video[data-lazy-video]');
  if (!vids.length) return;
  /* Affiches (data-poster) posées à l'approche du bloc (carrousel entier), pas au chargement de la page. */
  const poster = v => {if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster);};
  const go = v => {poster(v); if (v.dataset.ready !== '1') {v.dataset.ready = '1'; v.preload = 'auto'; v.load();} const p = v.play(); if (p && p.catch) p.catch(() => {});};
  if (!('IntersectionObserver' in window)) {vids.forEach(go); return;}
  const boxes = new Map();
  vids.forEach(v => {const box = v.closest('[data-bb-carousel]') || v; if (!boxes.has(box)) boxes.set(box, []); boxes.get(box).push(v);});
  const near = new IntersectionObserver(entries => entries.forEach(e => {if (e.isIntersecting) {(boxes.get(e.target) || []).forEach(poster); near.unobserve(e.target);}}), {rootMargin: '900px 0px'});
  boxes.forEach((_, box) => near.observe(box));
  const io = new IntersectionObserver(entries => entries.forEach(e => {if (e.isIntersecting) go(e.target); else if (!e.target.paused) e.target.pause();}), {rootMargin: '300px 0px'});
  vids.forEach(v => io.observe(v));
})();

/* Sections : carrousels, « voir plus d'avis » */
(() => {
  'use strict';
  document.querySelectorAll('[data-bb-carousel]').forEach(box => {
    const tr = box.querySelector('[data-bb-carousel-track]');
    const step = () => (tr.firstElementChild?.getBoundingClientRect().width || tr.clientWidth) + 20;
    box.querySelector('[data-bb-prev]')?.addEventListener('click', () => tr.scrollBy({left: -step(), behavior: 'smooth'}));
    box.querySelector('[data-bb-next]')?.addEventListener('click', () => tr.scrollBy({left: step(), behavior: 'smooth'}));
  });
  document.querySelectorAll('[data-bb-more]').forEach(btn => btn.addEventListener('click', () => {
    const hidden = [...document.querySelectorAll('.bb-review[hidden]')];
    hidden.slice(0, 10).forEach(el => {el.hidden = false;});
    if (hidden.length <= 10) btn.remove();
  }));
})();

/* Images différées des sections (data-lazy) : posées quand elles arrivent à 600 px de l'écran ; dans un carrousel, tout le
   carrousel d'un coup quand il approche. Sur réseau lent, Chrome chargeait d'office tout ce qui était à moins de 2 500 px
   (accueil : 1,1 Mo d'images partaient avec la bannière). Audit du 18/10/2026. */
(() => {
  'use strict';
  const imgs = [...document.querySelectorAll('img[data-lazy]')];
  if (!imgs.length) return;
  const set = img => {if (img.dataset.srcset) {img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset');} if (img.dataset.src) {img.src = img.dataset.src; img.removeAttribute('data-src');} img.removeAttribute('data-lazy');};
  if (!('IntersectionObserver' in window)) {imgs.forEach(set); return;}
  const groups = new Map();
  imgs.forEach(img => {const box = img.closest('[data-bb-carousel-track]') || img; if (!groups.has(box)) groups.set(box, []); groups.get(box).push(img);});
  const io = new IntersectionObserver(entries => entries.forEach(e => {if (e.isIntersecting) {(groups.get(e.target) || []).forEach(set); io.unobserve(e.target);}}), {rootMargin: '600px 0px'});
  groups.forEach((_, box) => io.observe(box));
})();
